import { createSlice } from '@reduxjs/toolkit';
import {
  FETCH_ALL_REVIEWERS_ACTIVE,
  ACTIVATE_REVIEWERS,
} from '../../../actions-index';
import { ERROR_CONSTS, STATUS } from '../../../util/constants';
import { sortByAttribute } from '../../../util/functions';

const initialState = {
  status: '',
  alert: ERROR_CONSTS.UI.GENERIC.EMPTY_ALERT,
};

const manageActiveReviewersSlice = createSlice({
  name: 'manageActiveReviewersReducer',
  initialState: {
    reviewers: { ...initialState, data: [], type: FETCH_ALL_REVIEWERS_ACTIVE },
    reviewerStatus: { ...initialState, data: null, type: ACTIVATE_REVIEWERS },
  },
  reducers: {
    fetchAllReviewersActive(state, action) {
      let reviewers = action.payload.data;
      return {
        ...state,
        reviewers: {
          status: action.payload.status ?? '',
          alert: action.payload.alert ?? '',
          data: reviewers ? sortByAttribute(reviewers, 'lastName') : [],
          type: FETCH_ALL_REVIEWERS_ACTIVE,
        },
      };
    },
    activateReviewers(state, action) {
      return {
        ...state,
        reviewerStatus: {
          status: action.payload.status ?? '',
          alert: action.payload.alert ?? '',
          data: action.payload.data ?? null,
          type: ACTIVATE_REVIEWERS,
        },
      };
    },
    updateReviewersStatus(state, action) {
      return {
        ...state,
        reviewers: {
          ...state.reviewers,
          data: state.reviewers.data.map((item) => {
            const reviewer = action.payload.reviewers.reviewers.find(
              (reviewer) => item.reviewerEmployeeId === reviewer
            );

            if (reviewer) {
              const newStatus = action.payload.reviewers.active
                ? STATUS.ACTIVE
                : STATUS.INACTIVE;
              item = { ...item, data: newStatus, status: newStatus };
            }
            return item;
          }),
        },
      };
    },
  },
  extraReducers: (builder) => {
    // Handle legacy action types dispatched by AlertBar dismiss flow
    builder.addCase(ACTIVATE_REVIEWERS, (state, action) => {
      return {
        ...state,
        reviewerStatus: {
          status: action.payload.status ?? '',
          alert: action.payload.alert ?? '',
          data: action.payload.data ?? null,
          type: ACTIVATE_REVIEWERS,
        },
      };
    });
  },
});
export const manageActiveReviewersReducer = manageActiveReviewersSlice.reducer;
